export type GlossaryItem = {
  term: string;
  icon: string;
  desc: string;
};

export const glossary: GlossaryItem[] = [
  {
    term: "事件时间线",
    icon: "ri-timeline-view",
    desc: "把分散在不同时间点的公开信息按发生顺序排列，让起因、回应与后续各自归位。",
  },
  {
    term: "源头追溯",
    icon: "ri-node-tree",
    desc: "顺着传播链条找到最早的公开发布方，避免把二手转述误当成原始信息。",
  },
  {
    term: "口径一致",
    icon: "ri-check-double-line",
    desc: "同一件事在不同渠道的说法是否统一。口径不一致，往往是讨论真正开始的地方。",
  },
  {
    term: "信息保鲜期",
    icon: "ri-time-line",
    desc: "热点信息的有效时长通常很短，超过这个窗口再看，需要重新确认是否已有更新。",
  },
  {
    term: "情绪放大器",
    icon: "ri-emotion-line",
    desc: "转述时被强化的情绪表达。它会让人记住态度，却容易模糊事实本身。",
  },
  {
    term: "官宣节奏",
    icon: "ri-megaphone-line",
    desc: "正式信息的发布时机。等待官宣并不等于落后，而是更省心的围观方式。",
  },
];